export const EstimatedShippingFeeLabelTextHelper = {
    getLabelText: {
        sku: 'SKU',
        estimatedShippingFeeAmount: 'Estimated Shipping Fee HKD',
        dateEffectiveOn: 'Effective Date',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        action: 'Action'
    }
};
